import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class TextUtils {

    capitalizeFirsLetter(text: string): string {
        if (text && text != '') {
            return text
                .toLowerCase()
                .replace(/^\w/, (char) => char.toUpperCase())
        } else {
            return text;
        }
    }

    capitalizeFirstLetters(text: string): string {
        return text
            .toLowerCase()
            .replace(/\p{L}\S*/gu, (word) => word.charAt(0).toUpperCase() + word.slice(1));
    }

}
